import { enUS as en, ru } from 'date-fns/locale';
import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { withControl } from '@features/effector-form/hoc/withControl';
import { getSafePickerLocale } from '@shared/utils/getSafePickerLocale';
import { theme } from '@unicorn/bms-theme';

const CalendarIcon = () => <CalendarToday sx={{ color: theme.palette.grey[700] }} />;

type Props = {
  sx?: object;
  sxForm?: object;
};

const EN = 'en';
const LNG = localStorage.getItem('lang') || EN;

export const MonthControl = withControl<Props>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    sx = {},
    sxForm = {},
    isError,
  }) => (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LNG === EN ? en : ru}
      localeText={getSafePickerLocale(LNG)}
    >
      <FormControl required={required} disabled={disabled} sx={sxForm}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <DatePicker
          views={['month']}
          openTo="month"
          value={value}
          readOnly={readOnly}
          disabled={disabled}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            textField: {
              error: isError,
              size: 'small',
            },
          }}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          sx={sx}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  )
);
